export default "worker/info.js"